// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"30":"84e46e87f527bc29","348":"327ef2ae6cbd2435","422":"cbb911b96a127634","728":"4fd29fb70da4162b","941":"7dc7171be061489a"}[chunkId] + ".js";
};